import { render, staticRenderFns } from "./consent-account-consents-tab.vue?vue&type=template&id=70b16bc7&scoped=true"
import script from "./consent-account-consents-tab.vue?vue&type=script&lang=js"
export * from "./consent-account-consents-tab.vue?vue&type=script&lang=js"
import style0 from "./consent-account-consents-tab.vue?vue&type=style&index=0&id=70b16bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b16bc7",
  null
  
)

export default component.exports